import styled from 'styled-components';
import Box from '../../atoms/Box';
import Heading from '../../atoms/Heading';
import Text from '../../atoms/Text';
export const Title = styled(Heading).attrs({
  fontSize: 5,
  fontWeight: 'light'
})``;
export const Description = styled(Box).attrs({
  fontSize: [0, 1, 2, 2],
  display: 'contents',
  color: 'text.light',
  mY: 3
})``;
export const InputLabel = styled(Text).attrs({
  mt: 3,
  mb: 1
})``;
export const ErrorMessage = styled(Text).attrs({
  color: 'error',
  mt: 1
})``;